import { MeetingFormValues } from "@/pages/workflows/edit/actions/meeting/workflow-meeting.schema.ts";
import { Select, SelectItem } from "@skailer-com/uikit";
import { Control, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface MeetingOrganizerFieldProps {
  control: Control<MeetingFormValues>;
  organizerOptions: SelectItem[];
  error?: string;
  onSearch: (text: string) => void;
  onOrganizerChange: (value: number | null) => void;
}

export const MeetingOrganizerField = ({
  control,
  organizerOptions,
  error,
  onSearch,
  onOrganizerChange,
}: MeetingOrganizerFieldProps) => {
  const { t } = useTranslation();

  return (
    <Controller
      control={control}
      name="organizer_id"
      render={({ field: { value } }) => (
        <Select
          label={t("workflow:action_type_meeting_organizer")}
          emptyTitle={t("common:select")}
          required
          value={value}
          options={organizerOptions}
          searchable
          showAvatar
          onSearchOptions={(text) => onSearch(text ?? "")}
          searchOptions={organizerOptions}
          loadOptionsOnOpen
          error={error}
          onChange={(newValue) => onOrganizerChange(newValue as number | null)}
        />
      )}
    />
  );
};
